import qs from 'qs'
import jsonp from 'jsonp'
import axios from './axios'

// const jsonpFn = (url, params)=>{
//   return new Promise((resolve, reject) => {
//     jsonp('/mdsp-web' + url + '?' + qs.stringify(params), null, (err, data) => {
//       if (err) {
//         reject(err)
//       } else {
//         resolve(data)
//       }
//     })
//   })
// }
// const probeAuthStatus = (query) => {
//   console.log('start probeAuthStatus----------', query)
//   return jsonpFn('/authStatus', query)
// };
// let timeMoment=+new Date;
/* 超过5分钟自动校验 */
// const checkTimeStamp = async ()=>{
//   if(+new Date - timeMoment>5*60*1000){
//     let auth= await probeAuthStatus()
//     if(!auth.hasLogin){
//       // 跳转至登录页面
//       window.location.href = snadBase.getMPassPortLoginURL(snadBase.URL_CONST.AP_HOST);
//     }
//     else{
//       timeMoment=+new Date
//       return Promise.resolve()
//     }
//   }else{
//     timeMoment=+new Date
//     return Promise.resolve()
//   }
// }
/**
 * [request description]
 * 封装axios方法
 *
 * request.get('/user/all', {a: 1, b: 2})
 * request.post('/user/all', {a: 1, b: 2})
 * request.jsonp('/user/all', {a: 1, b: 2})
 */

export default {
  get(url, params) {
    if (!params) {
      return axios.get(url)
    }
    return axios.get(url + '?' + qs.stringify(params))
  },
  post(url, params) {
    // let x= await checkTimeStamp()
    return axios.post(url, params)
  },
  jsonp(url, params, config = { timeout: 10000 }) {
    return new Promise((resolve, reject) => {
      jsonp(url + '?' + qs.stringify(params), config, (err, data) => {
        if (err) {
          reject(err)
        } else {
          resolve(data)
        }
      })
    })
  },
  postFile(url, params) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    return axios.post(url, params, config)
  }
}
